import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Typography, Box, CircularProgress } from "@mui/material";

import MaterialTable from "@material-table/core";

import { useSnackbar } from "notistack";
import { apiGet } from "@services/API";
import moment from "moment";

function headers() {
  let headers = {};

  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");

  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function AuditLogs({ ...props }) {
  const history = useHistory();

  const level = parseInt(localStorage.getItem("user_level"), 10);

  const hospitalID = localStorage.getItem("hospital_id");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(25);
  const [rowsPerPage, setRowsPerPage] = useState([5, 10, 25, 50, 75, 100]);

  useEffect(() => {
    const timeOut = setTimeout(() => {
      var admin_facility_id = localStorage.getItem("user_facility_id");

      apiGet(
        `/audit_log/` + admin_facility_id,
        {
          headers: headers(),
        },
        history
      )
        .then((response) => {
          if (level === 1 || level === 2 || level === 3) {
            setData(response.data);
          } else if (level === 5 || level === 6) {
            const filteredData = response.data.filter(
              (item) => Number(item.facility_id) === Number(hospitalID)
            );
            setData(filteredData);
          } else {
            setData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          showSnackBar("error", "Failure", "Failed to retrieve data.");
        });
    }, 200);

    return () => clearTimeout(timeOut);
  }, []);

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography data-test={"snack-title"} variant="h6">
          {title}
        </Typography>
        <Typography data-test={"snack-text"} variant="subtitle1">
          {subtitle}
        </Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const handleChangePage = (event) => {
    //event.target.value === 'All' ? setRowsPerPage(data.length) : setRowsPerPage(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event);
  };

  return (
    <Box style={{ margin: 10 }} data-test={"logs-table"}>
      <MaterialTable
        style={{}}
        title="Audit Logs"
        columns={[
          {
            title: "User",
            field: "firstname",
            render: (rowData) => {
              return (rowData.firstname =
                rowData.firstname + " " + rowData.surname);
            },
          },
          {
            title: "Audit Action",
            field: "action",
            width: "50%",
          },

          {
            title: "Timestamp",
            field: "timestamp",
            editable: "never",
            defaultSort: "desc",
            type: "datetime",
            render: (rowData) => {
              if (rowData.timestamp == null) {
                return "";
              } else {
                return moment(rowData.timestamp)
                  .local()
                  .format("DD/MM/yyyy HH:mm");
              }
            },
          },
          {
            title: "Hospital",
            field: "facility",
          },
        ]}
        data={data}
        options={{
          padding: "dense",
          addRowPosition: "first",
          exportAllData: true,
          filtering: false,
          pageSize: pageSize,
          pageSizeOptions: rowsPerPage,
          loadingType: "overlay",
          tableLayout: "auto",
          //minBodyHeight: "75vh",
          //maxBodyHeight: "75vh",
          headerStyle: {
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: "1",
          },
        }}
        isLoading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
}
